import { useEffect, useState } from "react"

const SelectMultiple = (questionNumber, getData,data,operation) => {

  const defaultSelectedOptions = (defaultData) => (
    defaultData?.options?.filter((option) => option.isCorrect)?.map((option) => option.value) || []
  );
  
  const [defaultSelectMOptions, SetDefaultSelectMOptions] = useState(data?.options||[])
  const [defaultQuestion, setDefaultQuestion] = useState(data?.question || "")
  const [defaultSelectedOps, setDefaultSelectedOps] = useState(defaultSelectedOptions(data))
  const [optionText, setOptionText] = useState("")
  const [score, setScore] = useState(0)
  const [description, setDescription] = useState("")
  const [selectMOptions, setSelectMOptions] = useState(data?.options||[])
  const [question, setQuestion] = useState(data?.question || "")
  const [selectedOptions, setSelectedOptions] = useState(operation === "preview"?[]:defaultSelectedOptions(data))

  const onChangeOptionText = (e) => { setOptionText(e.target.value) };
  const onChangeOptionScore = (v) => { setScore(v) };
  const onChangeDescription = (e) => { setDescription(e.target.value) };
  const onChangeQuestion = (e) => { setQuestion(e.target.value) };
  const onChangeSelectedOptions = (checkedValues) => {
    setSelectedOptions(checkedValues);
    let updatedOptions = [...selectMOptions]
    updatedOptions.forEach((option, index) => {
      if (checkedValues.includes(option.value)) { updatedOptions[index] = { ...option, isCorrect: true }; }
      else { updatedOptions[index] = { ...option, isCorrect: false } }
    });
    setSelectMOptions(updatedOptions)
  };

  const resetFields = () => { setQuestion(""); setOptionText(""); setScore(0); setDescription(""); setSelectMOptions([]) }
  const resetDefaultFields = () => { setQuestion(defaultQuestion);  setSelectMOptions(defaultSelectMOptions); setSelectedOptions(defaultSelectedOps) }


  const addOption = () => {
    if (optionText.length > 0, score > 0, description.length > 0) {
      let selectMOptionsUpdate = [...selectMOptions];
      selectMOptionsUpdate.push({ label: optionText, value: selectMOptions.length, score: score, isCorrect: false, description: description });
      setSelectMOptions(selectMOptionsUpdate);
      setOptionText(""); setScore(0); setDescription("")
    }
  };

  const deleteOption = (optionNumber) => {
    if (optionNumber >= 0) {
      let selectMOptionsUpdate = [...selectMOptions];
      selectMOptionsUpdate.splice(optionNumber, 1);
      setSelectMOptions(selectMOptionsUpdate);
    }
  };

  useEffect(() => {
   if(getData){getData(questionNumber, { question, options: selectMOptions })}
  }, [question, selectMOptions])




  return {
    optionText,
    onChangeOptionText,
    score,
    onChangeOptionScore,
    onChangeDescription,
    onChangeQuestion,
    question,
    selectMOptions,
    deleteOption,
    addOption,
    description,
    resetFields,
    selectedOptions,
    onChangeSelectedOptions,
    resetDefaultFields
  }
}
export default SelectMultiple